// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".game-controls[data-v-4bf8ab62]{height:var(--game-controls-h);padding-top:16px}.game-controls__inner[data-v-4bf8ab62]{display:flex;justify-content:space-between;height:32px}.game-controls__side[data-v-4bf8ab62]{display:flex;grid-gap:8px;gap:8px;align-items:center;justify-content:space-between;margin-left:auto}.game-controls__side-mr[data-v-4bf8ab62]{margin-right:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
